module.exports = __webpack_public_path__ + "static/media/logo-black.939145d2.svg";